export var ANCHOR_POINTS;
(function (ANCHOR_POINTS) {
    ANCHOR_POINTS["TOP_LEFT"] = "anchor-top-left";
    ANCHOR_POINTS["TOP_RIGHT"] = "anchor-top-right";
    ANCHOR_POINTS["BOTTOM_LEFT"] = "anchor-bottom-left";
    ANCHOR_POINTS["BOTTOM_RIGHT"] = "anchor-bottom-right";
})(ANCHOR_POINTS || (ANCHOR_POINTS = {}));
//# sourceMappingURL=anchor-points.js.map